// extracted by mini-css-extract-plugin
module.exports = {"counterWrap":"CartButton_counterWrap__2uxQi","counterValue":"CartButton_counterValue__3_h5o"};